var _circle, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerimetrionHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#0D5093"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3826_335",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3826_335",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsSAAALEgHS3X78AAAFAUlEQVR4nO2c3X3iOBTFT/Lb99DB0EH8UcDSwWQqGG8FSSpYUsFCBcNUsEkFwxRgm3TAdhAqYB8kEyNkfWFdC6P/G7Yulo+l4ytZ9s1+v0fEP7dDV+BaiEITEYUmIgpNRBSaiCg0EVFoIqLQREShifhj6ArYUFZ1AmAOYMI3zfMsXQ9WIQtuLmUIXlZ1AWAB4E7Y9Zxn6YK+RnYEL3RZ1RMwgb8rir0BKPIs/aCplT1BC82tYgXg3qD4fwAe8izdeK2UI8HeDLlVrCEXeQlgJ2z7AqAuq/rJb83cCK5Fa6zi0GrLqp4CeIX8QgRnJUEJrbEKqXhlVS8APErKB2UlwQhdVvUDmMhiVgFoMotzYqkIQug+WmXoVjKo0C7icHuZAPiQXYBQrWQwoV26e1nVcwB/tzb9BPAkuRgF5IObzv/2zSBC27Y6nom8AvhTEvPOY7ZCjPWN1SekQjtaxYzHyFpnw47HvgqxRqmiaf3PgUzonqxCxzLP0pMBi8JKdmDWs7I4hhMkQnuwigJsFu9rx35bK5F6fZ94FdqDVRy1WD7c/kdSzsVK3nmMFyvxJrTGKl7yLJ1LYqyE4zEJ2IX5IokLxkq8CK2wih1Yt14L5SdgF8XYCs6Np7aSXoXmJ7yGvPK/wU5YNgCxapGK4wdrJb0JrfHW3qzCoB4J2MXWenwrpoBnK+lFaEUa5sUqDOrT9wDnbCs5S2jNCXm3CoP6zdHdAEitxFnoUKxCh0262IpR1dPJSpyEDs0qdHjoedZWYiV06FahY8gGYiy0B6sgmWMQGcryjIT20BK8DXVNGKJnKoU2SJNmvr3NJ5RW0im04926wMDTkbZQWYlU6JDyTwoorORIaMfJGdX8RlBWoUPTwJKOc1/BQK/bVlACYNMRtMyz9ORAnCecirwD8FeepUGtFtLBbeIbTpeb3YE9aBDLf+RZ+gDgWfJ39wA2fLr4aO3dAqfdYAfgm+aOOhN+NzfJlSImWLgtJmDn0WaqiFkASMGeGLU5XKC20OIfvYN1F9th8VPIfmxCnqXbPEsTy5gN2AX6Ley6B46F3uKzy6isItIBt5IZgJfW5h3QerWCF4j0QJ6l87KqV2C2+gqc+Q4Lz0GtutgFk5RVXZjee7gbHMo6L0TnqdAvqBe2jIk7AD/Kql7xtM4Ka6HLqp6UVb2G3cKWMfEdwJqnw8ZYCc2tYgv5COqauAcTuzANMBb6Cq1CR2MlC5PC2puhwTzABGZvTV0672C9WRw5P/KernwIoGzRGqtY8pTwYobYZ2I83JbRKbTCKkyG5aNFM9z+t8tKToTWZBWuw/JR0Rpuv0l2P5ZV3byed+BI6NYMXpdVxGE5x2bmDjieJi0A1HCbwbtaTK3kFjisY/4h+Z9oFQYYWMmsadFTSYFoFRa0rORFsnvWlXWQLmwZE/wpzVLc3iX0teTGvjjRL9jPSIyN4L+pxCfQVV+faZAu6AmFoFs0z+tNRAZY7hrsQ4ighcbn18AunuCtQ2AHNnJtmEK+Uig4Lk3oTfshssMrzIMRunWMhig0EVFoIqLQREShiYhCExGFJqIrj57yJ+AmiKO3pKxq9xoJ/yUeS6jX1OOxRcRjq5iKG272+32zrOBXj5WKHPMSrYOIRuggpxZHxPbwVhafN5gNWZuRss6zdB7ER2CvgejRREShiYhCExGFJiIKTUQUmogoNBFRaCKi0EREoYn4H4w/eAlT9yyKAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerimetrionHome);
export default __webpack_public_path__ + "static/media/perimetrion_home.baaa0b6fd73b3e95dc468e93ca3213f2.svg";
export { ForwardRef as ReactComponent };